export const ADS_ANALYTICS_QUERY_INFO = 'adsAnalyticsQueryInfo';
